/* eslint-disable @next/next/no-img-element */
import React, { FC, LegacyRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import HomeSearchSkeleton from './homeSearchSkeleton/HomeSearchSkeleton';
import { SearchResult, searchSuggestion } from '@/redux/store/actions/home';
import useRemoveBodyScroll from '@/components/houses/_hooks/useRemoveBodyScroll';
import styles from './SearchDropDown.module.scss';
import Box from '@/components/UI/box/Box';
import NoResult from '@/components/reusable/home/searchDropDown/noResult/NoResult';
import Suggestion from '@/components/reusable/home/searchDropDown/suggestion/Suggestion';
import Results from '@/components/reusable/home/searchDropDown/results/Results';
import MobileForm from '@/components/reusable/home/searchDropDown/mobileForm/MobileForm';
import Typography from '@/components/UI/typography/Typography';
interface SearchBoxDropsdownProps {
  open?: boolean;
  handleClickCity?: any;
  searchTxt: any;
  setSearchTxt: any;
  forwardRef?: React.Ref<any>;
  setOpen: any;
  userLocation?: any;
  ref?: LegacyRef<any>;
  handleLocation?: any;
  searchInputRef?: any;
  handleCleanClose?: () => void;
  isMidTerm: boolean;
}
const defaultResultData = {
  houses: [],
  near_regions: [],
  regions: []
};
const SearchDropDown: FC<SearchBoxDropsdownProps> = ({
  open,
  handleClickCity,
  searchTxt,
  setSearchTxt,
  setOpen,
  forwardRef,
  searchInputRef,
  handleCleanClose,
  isMidTerm
}) => {
  const [searchLoading, setSearchLoading] = useState<boolean>(false);
  const searchTimeout = useRef<any>(null);
  const [searchResult, setSearchResult] = useState<SearchResult>(defaultResultData);
  const searchContent = useRef<HTMLDivElement>(null);
  const clearInput = useRef<HTMLSpanElement>(null);
  const isPhrase = useRef(false);
  const reduxDispatch = useDispatch();
  const hasResult = +searchResult.houses?.length || +searchResult.near_regions?.length || +searchResult.regions?.length;
  const resultExists = searchTxt?.trim().length > 1 && !searchLoading && hasResult;
  const handleSearch = e => {
    setSearchTxt(e.target.value);
    isPhrase.current = true;
  };
  const handleWindowClick = e => {
    if (window.innerWidth < 768) {
      return;
    }
    if (!(searchInputRef.current?.contains(e.target) || searchContent.current?.contains(e.target) || clearInput.current?.contains(e.target))) {
      return setOpen(false);
    }
  };
  useEffect(() => {
    window.addEventListener('click', handleWindowClick);
    return () => {
      window.removeEventListener('click', handleWindowClick);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (searchTimeout.current) {
      clearTimeout(searchTimeout.current);
    }
    if (process.env.OFFLINE_MODE === 'true') {
      setSearchLoading(false);
      setSearchResult(defaultResultData);
      return;
    }
    if (searchTxt?.length > 1) {
      setSearchLoading(true);
      searchTimeout.current = setTimeout(() => {
        reduxDispatch(searchSuggestion(searchTxt, (resultData: SearchResult) => {
          setSearchLoading(false);
          if (resultData) {
            setSearchResult(resultData);
          }
        }));
      }, 200);
    } else {
      setSearchResult(defaultResultData);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchTxt]);
  useEffect(() => {
    if (window.innerWidth < 768) {
      if (open) {
        document.body.classList.add('fixed-for-iphone');
      } else {
        document.body.classList.remove('fixed-for-iphone');
      }
    }
  }, [open]);
  const mainList = searchResult.regions?.concat(searchResult.near_regions);
  const allResult = mainList?.filter(item => item.type === 'city')?.concat(mainList.filter(item => item.type === 'province'))?.concat(mainList.filter(item => item.type === 'village'));
  useRemoveBodyScroll(open);
  const noResult = searchTxt?.trim().length > 1 && !searchResult.houses?.length && !searchResult.near_regions?.length && !searchResult.regions?.length && !searchLoading;
  useImperativeHandle(forwardRef, () => ({
    noResult: !!noResult,
    allResult
  }));
  if (!open) return null;
  const handleClean = () => {
    setSearchTxt('');
  };
  return <Box className={styles['container']} ref={searchContent} data-sentry-element="Box" data-sentry-component="SearchDropDown" data-sentry-source-file="SearchDropDown.tsx">
      <MobileForm searchTxt={searchTxt} handleClickCity={handleClickCity} closeHandler={() => setOpen(false)} isPhrase={isPhrase} searchContent={searchContent} allResult={allResult} handleClean={handleClean} handleCleanClose={handleCleanClose} handleSearch={handleSearch} data-sentry-element="MobileForm" data-sentry-source-file="SearchDropDown.tsx" />
      {searchTxt.includes('جستجو') ? <Typography variant="bodyM" className={styles['midterm-noresult']}>
          عبارت مورد نظر را جستجو کنید...
        </Typography> : <>
          {noResult || isMidTerm ? !!searchTxt ? <NoResult searchTxt={searchTxt} closeHandler={() => setOpen(false)} isMidTerm={isMidTerm} /> : <>
                <Typography variant="bodyM" className={styles['midterm-noresult']}>
                  عبارت مورد نظر را جستجو کنید...
                </Typography>
              </> : searchLoading ? <HomeSearchSkeleton /> : resultExists ? <Results searchResult={searchResult} closeHandler={() => setOpen(false)} searchTxt={searchTxt} handleClickCity={handleClickCity} /> : <Suggestion setSearchTxt={setSearchTxt} closeHandler={() => setOpen(false)} isPhrase={isPhrase} handleClickCity={handleClickCity} />}
        </>}
    </Box>;
};
const ExportedSearchDropdown: FC<SearchBoxDropsdownProps> = React.forwardRef((props, ref) => <SearchDropDown {...props} forwardRef={ref} />);
export default ExportedSearchDropdown;